import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { finalBadges, noMore } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full bg-sand py-10 sm:py-12" aria-labelledby="final-cta-heading" data-id="element-87" data-mp="3qtjd2tl5260b">
      <div className="mx-auto max-w-4xl px-6" data-id="element-88" data-mp="3vscirzu6ospx">
        <div className="mx-auto max-w-2xl text-center" data-id="element-89" data-mp="3vs44q4mbrhd5">
          <p className="eyebrow text-terracotta-deep" data-id="element-90" data-mp="2y5dtia5tmn22">Your next teaching week</p>
          <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-xl font-display text-[2rem] leading-[1.12] text-ink sm:text-4xl" data-id="element-91" data-mp="333yj7fng5oc9">
            You can build the next few classes from scratch — or walk in with
            everything ready.
          </h2>
        </div>

        <ul className="mx-auto mt-9 grid max-w-3xl gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-92" data-mp="3cv2wmaxh514z">
          {noMore.map(item => <li key={item} className="flex items-start gap-2.5 font-sans text-[0.9rem] leading-relaxed text-ink/85" data-id="element-93" data-mp="2fc9x4h17xw3r">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" aria-hidden="true" data-id="element-94" data-mp="2dc0dox3lnj31" />
              {item}
            </li>)}
        </ul>

        <div className="mt-10 rounded-4xl bg-indigo-deep px-7 py-10 text-center shadow-lift sm:px-12" data-id="element-95" data-mp="28e8d7eow2on8">
          <p className="mx-auto max-w-xl font-display text-xl leading-snug text-ivory sm:text-2xl" data-id="element-96" data-mp="23km94awsjt31">
            THE ART FLOW ARCHIVE™ doesn’t make you a better teacher — you’re
            already the teacher.
          </p>
          <p className="mx-auto mt-4 max-w-lg font-sans text-[0.95rem] leading-relaxed text-gold-soft" data-id="element-97" data-mp="1ujfq9v6o666m">
            What it gives you is the time and the tools to make your teaching
            visible in every class.
          </p>

          <CtaButton size="large" className="mt-9" data-id="element-98" data-mp="1forl6i56l9rj">
            Get the complete system now
          </CtaButton>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-99" data-mp="3f1lvkpwgjdp5">
            {finalBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-ivory/70" data-id="element-100" data-mp="3a3kcw62y1ge7">
                <CheckIcon className="h-3.5 w-3.5 text-gold" strokeWidth={2.4} aria-hidden="true" data-id="element-101" data-mp="18bio23fpcbvb" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}